const PORT = 2345;
const ENDPOINT = "/api/v1/currencies/convert";
const API_BASE_URL = process.env.CURRENCY_API_BASE_URL;

const formatApiBaseUrl = (baseUrl) => baseUrl.replace(/\/+$/, "");

const getBrowserApiBaseUrl = () => {
  if (typeof window === "undefined" || !window.location?.hostname) {
    return `http://localhost:${PORT}`;
  }

  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}:${PORT}`;
};

const getApiBaseUrl = () => {
  if (API_BASE_URL) {
    return formatApiBaseUrl(API_BASE_URL);
  }

  const isDev = process.env.NODE_ENV === "development";
  return isDev ? "" : getBrowserApiBaseUrl();
};

const parseExchangeRate = (payload) => {
  if (typeof payload === "number" && Number.isFinite(payload)) {
    return payload;
  }

  if (!payload || typeof payload !== "object") {
    return null;
  }

  const candidates = [ payload.exchangeRate,
    payload.exchange_rate,
    payload.rate,
    payload?.data?.exchangeRate,
    payload?.data?.exchange_rate,
    payload?.data?.rate,
  ];

  const validRate = candidates.find((value) => Number.isFinite(Number(value)));
  if (validRate) {
    return Number(validRate);
  }

  const convertedAmount = Number(payload?.data?.convertedAmount ?? payload?.data?.converted_amount ?? payload?.convertedAmount ?? payload?.converted_amount);
  const amount = Number(payload?.data?.amount ?? payload?.amount);

  if (Number.isFinite(convertedAmount) && Number.isFinite(amount) && amount > 0) {
    return convertedAmount / amount;
  }

  return null;
};

const getExchangeRate = async ({ base = "usd", target = "inr", amount = 1 } = {}) => {
  const searchParams = new URLSearchParams({ base, target, amount: String(amount) });
  const url = `${getApiBaseUrl()}${ENDPOINT}?${searchParams.toString()}`;

  const response = await fetch(url, {
    headers: {
      Accept: "application/json",
    },
  });

  const rawResponse = await response.text();

  if (!response.ok) {
    throw new Error(`Exchange rate request failed with status ${response.status}`);
  }

  let payload;
  try {
    payload = JSON.parse(rawResponse);
  } catch (error) {
    throw new Error(
      `Exchange rate API returned non-JSON response at ${url}. ` +
      "In local dev, restart the React server after proxy changes and verify /api requests are being proxied."
    );
  }

  const rate = parseExchangeRate(payload);

  if (!Number.isFinite(rate)) {
    throw new Error("Exchange rate response does not contain a valid rate");
  }

  return rate;
};

export default getExchangeRate;